export default __webpack_public_path__ + "static/media/arrow.62750802.svg";